<div class="app-modal tw-flex tw-flex-col tw-gap-4 tw-text-right">
  <header class="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-text-center">
    <img *ngIf="svg" [src]="svg" alt="" class="tw-h-16 tw-w-auto" />
    <h5 class="tw-m-0 smsir-h5-lg tw-text-[rgb(var(--text-primary))]">
      {{ modalHeader }}
    </h5>
  </header>

  <div class="modal-table tw-flex tw-flex-col tw-gap-2">
    <div class="modal-table__item" *ngFor="let itemKey of objectKeys(data)">
      <div class="modal-table__item--header smsir-helper-md tw-text-[rgb(var(--text-secondary))]">
        {{ itemKey }}
      </div>
      <div
        class="modal-table__item--value smsir-helper-lg tw-text-[rgb(var(--text-primary))]"
        id="scrollbar-style"
      >
        {{ data[itemKey] }}
      </div>
    </div>
  </div>

  <div class="tw-flex tw-w-full tw-justify-end tw-gap-2">
    <button
      type="button"
      smsir-button
      variant="text"
      size="sm"
      class="tw-min-w-0 tw-flex-1 md:tw-w-auto md:tw-flex-none"
      (click)="dismiss()"
    >
      بازگشت
    </button>
  </div>
</div>
